




















































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import { AxiosResponse } from "axios";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404.vue";
import { ICategory } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    NavigationTabs,
    Error404
  }
})
export default class EventCategoryDetails extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["name"];
  private noDataExist = false;
  private originalName: string | null = null;
  private selectedCategory: ICategory = {
    name: null
  };
  private selectedCategoryId: string | null = null;
  private failedRequest = false;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedCategoryId = vm.$route.params.category_id;
      if (
        typeof vm.selectedCategoryId !== "undefined" &&
        vm.selectedCategoryId !== null
      ) {
        if (vm.$route.query.category_created === "true") {
          swal("Success!", "The category was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getCategory(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedCategoryId !== "undefined" &&
      this.selectedCategoryId !== null
    ) {
      this.getCategory(() => {
        //
      });
    }
    next();
  }

  private createOrUpdateCategory(): void {
    if (this.selectedCategoryId == null) {
      this.createCategory();
    } else {
      this.updateCategory();
    }
  }

  private createCategory(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("categories");

    Api()
      .post(endpoint, this.selectedCategory)
      .then((response: AxiosResponse) => {
        this.selectedCategoryId = response.data.data.id;
        this.$router.push({
          name: "EventCategoryDetails",
          params: { category_id: `${this.selectedCategoryId}` },
          query: { category_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#category-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getCategory(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "categories/" + this.selectedCategoryId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedCategory = response.data.data;
        if (this.selectedCategory.name) {
          this.originalName = this.selectedCategory.name;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateCategory(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "categories/" + this.selectedCategoryId
    );

    Api()
      .put(endpoint, this.selectedCategory)
      .then(() => {
        this.getCategory(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The category was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#category-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteCategory(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The category will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "categories/" + this.selectedCategoryId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "EventCategories",
              query: { category_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete categories.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }
}
